import {defineStore} from 'pinia';
import {ref, watch} from 'vue';

export const useSettingsStore = defineStore('settings', () => {
	// --- State ---
	// Initialize language from localStorage or default to 'en'
	const cultureInfo = ref(localStorage.getItem('culture-info') || 'et-EE'); // Default to Estonian
	const language = getCookie('language');
	if (language === 'et') setCulture('et-EE');
	if (language === 'en') setCulture('en-IE');
	if (language === 'ru') setCulture('ru-RU');

	// --- Actions ---
	function setCulture(newLang: string) {
		cultureInfo.value = newLang;
	}

	// --- Persistence ---
	// Watch for changes in the language state and save to localStorage
	watch(cultureInfo, (newLang) => {
		localStorage.setItem('culture-info', newLang);
	});

	return {cultureInfo, setCulture};
});

export function getCookie(name: string): string | null {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	return match ? decodeURIComponent(match[2]) : null;
}